// will toggle dropdown menu
let dropdownOpen = false;

// toggle the dropdown
function toggleMenu() {
    dropdownOpen = !dropdownOpen;
    let dropdownMenu = document.getElementById('dropdown');
    if (dropdownOpen) {
        dropdownMenu.style.display = 'block';
    } else {
        dropdownMenu.style.display = 'none';
    }
}

function DropdownNav() {
    return (
        <div>
            <div id="dropdown-container">
                {/* dropdown menu toggle button */}
                <button onClick={toggleMenu} type="button" id="dropdown-btn">☰</button>    

                {/* dropdown menu display */}
                <div style={{display:'none'}} id="dropdown">
                    <ul id="dropdown-ul">
                        <li className="top-bar-li"><a style={{textDecoration:'none'}} href="/"><span id="menu-item-xs">Home</span></a></li>
                        <li className="top-bar-li"><a style={{textDecoration:'none'}} href="/about"><span id="menu-item-xs">About</span></a></li>
                        <li className="top-bar-li"><a style={{textDecoration:'none'}} href="/services"><span id="menu-item-xs">Services</span></a></li>
                        <li className="top-bar-li"><a style={{textDecoration:'none'}} href="/contact"><span id="menu-item-xs">Contact</span></a></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
export default DropdownNav;